module.exports = __webpack_public_path__ + "img/casa.44980baa.svg";